import React, { Fragment} from 'react';

const LinksUsage = () => (
  <Fragment>
    <section>
      <article className="flex-justify-end flex-row">
        <div className="left">
          <h1 className="h1 page-title">
            Links are used primarily as a navigational element.
          </h1>
        </div>
        <div className="right copy-content">
          <p>Links are used to embed actions or pathways to more information in a sentence. Links are used primarily as a navigational element. Links may also change what or how data is displayed: view more, show all…</p>
        </div>
      </article>
    </section>

    <section className="bg-grey with-padding flex-grow-1">
      <article className="flex-justify-end flex-row last">
        <div className="right">
          <p>A Link is the lightest weight clickable control, and is often used to reduce the visual complexity of a design. Don’t use a link if the action is destructive or irreversible. Because users associate links with navigation (and the ability to back out), Links aren’t appropriate for commands with significant consequences.</p>
        </div>
      </article>
    </section>
  </Fragment>
);

export default LinksUsage;



// WEBPACK FOOTER //
// ./src/containers/elements/Links/LinksUsage.js